interface ClassObject {
  [key: string]: boolean | any;
}

interface BemObject {
  className: string;
  componentClassName: string;
  element: (el: string, modifiers?: ClassObject) => string;
}

function classCat(classObj: ClassObject, prefix = ''): string {
  return Object.keys(classObj)
    .map(key => {
      const value = classObj[key];
      if (
        (typeof value === 'function' && value()) ||
        (typeof value !== 'function' && value)
      ) {
        return `${prefix}${key} `;
      }
      return '';
    })
    .join('');
}

export function bemComponent(
  componentName: string,
  modifiers?: ClassObject
): BemObject {
  const componentClass = componentName;
  const prefixedClassNames = modifiers
    ? classCat(modifiers, `${componentClass}--`)
    : '';
  return {
    get className() {
      return `${componentClass} ${prefixedClassNames}`.trim();
    },
    get componentClassName() {
      return componentClass;
    },
    element: (el, mod) => {
      const className = `${componentClass}__${el}`.trim();
      if (mod) {
        const modifierClass = classCat(mod, `${className}--`);
        return `${className} ${modifierClass}`.trim();
      }
      return className;
    },
  };
}
